import Vue from 'vue';
import {
  getShopDetail, getBackendTagByMobile} from '../../../services/crmService/memberService';

// initial state
// state 必為模組區域變數，取時需 store.state.auth.user
// 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
// 區域使用時值需加上 name
const state = {
  shopDetail: null,
  memberBackendTag: []
};

// getters
const getters = {};

// actions
const actions = {
  // 取得會員消費記錄相關資訊
  async getShopDetailHandler({ commit}, mobile) {
    const data = await getShopDetail(mobile);
    commit('setShopDetail', data.data);
    return data;
  },
  // 取得會員後台標籤
  async getBackendTagByMobileHandler({ commit}, mobile) {
    const data = await getBackendTagByMobile(mobile);
    commit('setMemberBackendTag', data.data);
    return data;
  },
};

// mutations
const mutations = {
  setShopDetail(state, data) {
    Vue.set(state, 'shopDetail', data);
  },
  setMemberBackendTag(state, data) {
    Vue.set(state, 'memberBackendTag', data);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
